const initLineBreaker = () => {
  let titles = document.querySelectorAll('.feature__title');

  titles.forEach(title => {
    title.innerHTML = formatText(title);
  });
};

const formatText = title => {
  let text_arr = title.textContent.trim().split(' '),
    last_word = text_arr.pop();

  return (
    text_arr.join(' ') +
    (text_arr.length > 0
      ? " <span class='feature__title-last'>" + last_word + '</span>'
      : last_word)
  );
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.feature-grid')) {
    initLineBreaker();
  }
});
